import NewlineText from "./NewlineText"
import React from "react"

export default function Text({ text, technicalInformation = false }) {
    return (
        <NewlineText text={text} technicalInformation={technicalInformation} />
    )
}
